/*
 * Free-shipping celebration.
 *
 * Fires a one-shot confetti burst of little WALD smiley discs (organic "sea-glass"
 * shape, black face) + a subtle pulse on the free-shipping bar the moment the cart
 * crosses the free-shipping threshold — in both the cart drawer and the full cart
 * page. Detection is cart-total based (see handleTotal) so a stale bar on one
 * surface can't mask the crossing.
 *
 * Respects prefers-reduced-motion (no confetti, no pulse).
 */
(function () {
  if (window.__waldFsCelebration) return;
  window.__waldFsCelebration = true;

  var REACHED = '.cart-drawer__shipping-bar--reached';
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Any `--reached` bar present in the DOM (visible or not) — used for transition detection.
  function reachedExists() {
    return !!document.querySelector(REACHED);
  }

  // Pick the reached bar to anchor the confetti to: a currently on-screen one wins
  // (e.g. an open drawer); otherwise any rendered reached bar (e.g. the cart-page bar
  // scrolled out of view). Never a screen-centre guess.
  function pickBar() {
    var els = document.querySelectorAll(REACHED);
    var drawerOpen = !!document.querySelector('cart-drawer.active');
    var onScreen = null;
    var offscreen = null;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var cs = window.getComputedStyle(el);
      if (cs.visibility === 'hidden' || cs.display === 'none') continue;
      var r = el.getBoundingClientRect();
      if (r.width <= 0 || r.height <= 0) continue;
      var visible = r.bottom > 0 && r.top < window.innerHeight;
      // When the drawer is open its bar is what the user sees — always prefer it over
      // the cart-page bar sitting behind the overlay.
      if (drawerOpen && el.closest('cart-drawer') && visible) return el;
      if (visible && !onScreen) onScreen = el;
      if (!offscreen) offscreen = el;
    }
    return onScreen || offscreen;
  }

  var prevReached = false;
  var lastFire = 0;

  // Detection is cart-total based, not DOM based: the page can hold two shipping bars
  // (cart page + drawer) that drift out of sync, so a stale "reached" bar would mask the
  // crossing. Comparing the live cart total to the threshold works for every surface.
  function handleTotal(totalCents) {
    var thr = typeof window.WALD_FS_THRESHOLD_CENTS === 'number' ? window.WALD_FS_THRESHOLD_CENTS : 0;
    if (!thr || typeof totalCents !== 'number') return;
    var now = totalCents >= thr;
    if (now && !prevReached) celebrate();
    prevReached = now;
  }

  function celebrate() {
    if (reduceMotion) return;
    // Once-per-crossing already (prevReached), but guard against a double-fire from two
    // cart events landing within a moment of each other (e.g. add + section re-render).
    var nowMs = Date.now();
    if (nowMs - lastFire < 1400) return;
    lastFire = nowMs;
    injectCss();
    var tries = 0;
    // Keep retrying while the drawer opens — pickBar() only returns a visible bar, so this
    // naturally waits until the drawer has slid fully into view before firing.
    (function attempt() {
      var bar = pickBar();
      if (bar) return fireAtBar(bar);
      if (tries++ < 40) setTimeout(attempt, 120);
    })();
  }

  // Always anchor to the bar. If it's off-screen, scroll it into view and wait until it
  // actually IS in view before firing — otherwise the burst would originate below/above
  // the viewport and the first frame would self-clean (nothing visible). The origin Y is
  // also clamped into the viewport as a safety net.
  function fireNow(bar) {
    var r = bar.getBoundingClientRect();
    var cy = Math.max(48, Math.min(window.innerHeight - 48, r.top + r.height / 2));
    pulse(bar);
    // Emit along the whole bar width, not just from its centre.
    fireConfetti(r.left, r.width, cy);
  }

  function fireAtBar(bar) {
    // If the bar lives in a drawer that's still sliding in, its position keeps moving —
    // wait until it stops (the open animation has finished) before anchoring, otherwise the
    // burst lands where the bar WAS mid-animation, not where it ends up. The drawer slides
    // in HORIZONTALLY (translateX from the right), so its top stays constant the whole time
    // while left keeps moving — polling top alone thinks it has settled instantly and fires
    // off to the right. Poll BOTH edges; only fire once top AND left have stopped moving.
    var lastTop = null,
      lastLeft = null,
      stable = 0,
      tries = 0;
    (function settle() {
      var r = bar.getBoundingClientRect();
      var top = Math.round(r.top),
        left = Math.round(r.left);
      if (lastTop !== null && Math.abs(top - lastTop) <= 1 && Math.abs(left - lastLeft) <= 1) stable++;
      else stable = 0;
      lastTop = top;
      lastLeft = left;
      if (stable >= 2 || tries++ > 36) {
        fireWhenInView(bar);
        return;
      }
      setTimeout(settle, 50);
    })();
  }

  function fireWhenInView(bar) {
    var r = bar.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      fireNow(bar);
      return;
    }
    try {
      bar.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      bar.scrollIntoView();
    }
    var tries = 0;
    (function waitInView() {
      var rr = bar.getBoundingClientRect();
      if ((rr.top < window.innerHeight && rr.bottom > 0) || tries++ > 14) {
        fireNow(bar);
        return;
      }
      setTimeout(waitInView, 80);
    })();
  }

  function pulse(bar) {
    if (reduceMotion) return;
    try {
      bar.classList.remove('wald-fs-pop');
      // reflow so the animation can re-trigger on repeat celebrations
      void bar.offsetWidth;
      bar.classList.add('wald-fs-pop');
      setTimeout(function () {
        bar.classList.remove('wald-fs-pop');
      }, 900);
    } catch (e) {}
  }

  /* ---------------------------------------------------------------- confetti */

  // Blue-led WALD palette plus warm + soft accents drawn from the real smiley products
  // (amber, orange, mint, cream). Blue ~half, yellow/amber the next chunk, the rest a
  // sprinkle of accent colour for variety. No rainbow.
  function pickColor() {
    var x = Math.random();
    if (x < 0.26) return '#7CC4FA'; // light blue (WALD, dominant)
    if (x < 0.4) return '#4FA6E8'; // mid blue
    if (x < 0.48) return '#2E6CA6'; // deep blue
    if (x < 0.7) return '#FADB5F'; // WALD yellow
    if (x < 0.82) return '#F2B847'; // amber
    if (x < 0.9) return '#E98A3C'; // orange accent
    if (x < 0.96) return '#B9E0D0'; // mint accent
    return '#F3E9DA'; // cream accent
  }

  // Stable per-particle pseudo-noise so each smiley keeps its own organic outline across
  // frames (no per-frame jitter).
  function fsNoise(seed, i) {
    var x = Math.sin(seed * 127.1 + i * 311.7) * 43758.5453;
    return x - Math.floor(x);
  }

  // Organic "sea-glass" disc: 8 points with gentle radius noise, smoothed into soft
  // bezier curves (midpoint-quadratic) so the edge is round, never faceted.
  function seaglassPath(ctx, r, seed) {
    var n = 8;
    var rm = [];
    for (var i = 0; i < n; i++) rm.push(1 + (fsNoise(seed, i) - 0.5) * 0.22);
    function pt(i) {
      var a = (i / n) * Math.PI * 2;
      var rad = r * rm[i % n];
      return [Math.cos(a) * rad, Math.sin(a) * rad];
    }
    var pl = pt(n - 1);
    var p0 = pt(0);
    ctx.beginPath();
    ctx.moveTo((pl[0] + p0[0]) / 2, (pl[1] + p0[1]) / 2);
    for (var j = 0; j < n; j++) {
      var c = pt(j);
      var nx = pt((j + 1) % n);
      ctx.quadraticCurveTo(c[0], c[1], (c[0] + nx[0]) / 2, (c[1] + nx[1]) / 2);
    }
    ctx.closePath();
  }

  // Simple black smiley face (two eyes + a curved mouth) — reads on every disc colour.
  function drawFace(ctx, r) {
    ctx.fillStyle = '#121212';
    ctx.strokeStyle = '#121212';
    var ex = r * 0.34;
    var ey = -r * 0.15;
    var eyeR = Math.max(1, r * 0.115);
    ctx.beginPath();
    ctx.arc(-ex, ey, eyeR, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.arc(ex, ey, eyeR, 0, Math.PI * 2);
    ctx.fill();
    ctx.lineWidth = Math.max(1.4, r * 0.12);
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.arc(0, r * 0.05, r * 0.46, 0.2 * Math.PI, 0.8 * Math.PI);
    ctx.stroke();
  }

  function drawSmiley(ctx, x, y, r, rot, color, seed, alpha) {
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.translate(x, y);
    ctx.rotate(rot);
    seaglassPath(ctx, r, seed);
    ctx.fillStyle = color;
    ctx.fill();
    // soft sheen for a polished-stone feel
    ctx.beginPath();
    ctx.ellipse(-r * 0.26, -r * 0.32, r * 0.4, r * 0.24, -0.5, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(255,255,255,0.16)';
    ctx.fill();
    drawFace(ctx, r);
    ctx.restore();
  }

  function fireConfetti(barLeft, barWidth, originY) {
    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText =
      'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:2147483647;';
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    function resize() {
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize);

    var particles = [];
    // Light density — a calm, contained burst rather than a wide blast.
    var count = window.innerWidth < 600 ? 36 : 50;
    for (var i = 0; i < count; i++) {
      // Narrow, mostly-upward fan so the burst rises instead of spraying to the sides.
      var angle = -Math.PI / 2 + (Math.random() - 0.5) * (Math.PI * 0.5);
      var speed = 5 + Math.random() * 7;
      particles.push({
        x: barLeft + Math.random() * barWidth,
        y: originY,
        vx: Math.cos(angle) * speed + (Math.random() - 0.5) * 1.5,
        vy: Math.sin(angle) * speed - Math.random() * 2,
        r: 8 + Math.random() * 6,
        color: pickColor(),
        rot: Math.random() * Math.PI * 2,
        vr: (Math.random() - 0.5) * 0.32,
        seed: Math.random() * 1000,
        life: 0,
        ttl: 150 + Math.random() * 90,
      });
    }

    var gravity = 0.26;
    var drag = 0.992;
    var raf;
    // Advance by the real elapsed time (expressed in 60fps-equivalent steps) instead of a
    // fixed per-frame step, so the burst runs at the same speed regardless of the display's
    // refresh rate. Firefox on high-refresh phones (90/120 Hz) was playing it ~1.5–2× too
    // fast; this normalises it without changing the look on 60 Hz.
    var nowFn =
      window.performance && window.performance.now
        ? function () { return window.performance.now(); }
        : function () { return Date.now(); };
    var lastT = nowFn();
    function frame() {
      var t = nowFn();
      var dt = (t - lastT) / (1000 / 60);
      lastT = t;
      if (!(dt > 0)) dt = 1; // first frame / clock anomaly
      if (dt > 4) dt = 4; // clamp after a stall so particles don't teleport
      var fdrag = Math.pow(drag, dt);
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      var alive = false;
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        if (p.life > p.ttl) continue;
        p.life += dt;
        p.vx *= fdrag;
        p.vy = p.vy * fdrag + gravity * dt;
        p.x += p.vx * dt;
        p.y += p.vy * dt;
        p.rot += p.vr * dt;
        if (p.y < window.innerHeight + 50) alive = true;
        // Hold full opacity, then fade out over the last 30% of life.
        var lt = p.life / p.ttl;
        var fade = lt < 0.7 ? 1 : Math.max(0, 1 - (lt - 0.7) / 0.3);
        drawSmiley(ctx, p.x, p.y, p.r, p.rot, p.color, p.seed, fade);
      }
      if (alive) {
        raf = requestAnimationFrame(frame);
      } else {
        cleanup();
      }
    }
    function cleanup() {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
      if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
    }
    frame(); // paint the first frame synchronously, then keep animating via rAF
    // Safety net so a hidden tab / stalled rAF never leaves the canvas behind.
    setTimeout(cleanup, 5000);
  }

  /* --------------------------------------------------------------- pulse css */

  function injectCss() {
    if (document.getElementById('wald-fs-celebration-css')) return;
    var style = document.createElement('style');
    style.id = 'wald-fs-celebration-css';
    style.textContent =
      '@keyframes waldFsPop{0%{transform:scale(1)}28%{transform:scale(1.045)}55%{transform:scale(0.992)}100%{transform:scale(1)}}' +
      '.cart-drawer__shipping-bar--reached.wald-fs-pop{animation:waldFsPop .7s cubic-bezier(.2,.8,.3,1);transform-origin:center;}' +
      '@media (prefers-reduced-motion: reduce){.cart-drawer__shipping-bar--reached.wald-fs-pop{animation:none;}}';
    document.head.appendChild(style);
  }

  /* ------------------------------------------------------------------ wiring */

  function init() {
    // Seed from the server-rendered cart total (the DOM bars are unreliable where the
    // drawer is closed, e.g. a PDP — the bar lives in a <template>), so an already-
    // qualifying cart never false-fires; only a real crossing does. Fall back to the DOM.
    var seedThr = typeof window.WALD_FS_THRESHOLD_CENTS === 'number' ? window.WALD_FS_THRESHOLD_CENTS : 0;
    prevReached = seedThr
      ? typeof window.WALD_CART_TOTAL_CENTS === 'number' && window.WALD_CART_TOTAL_CENTS >= seedThr
      : reachedExists();

    function reconcileFromServer() {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { handleTotal(c.total_price); })
        .catch(function () {});
    }

    function onCartUpdate(event) {
      var total =
        event && event.cartData && typeof event.cartData.total_price === 'number'
          ? event.cartData.total_price
          : null;
      if (total !== null) {
        handleTotal(total);
        return;
      }
      // Some sources (e.g. add-to-cart from a PDP) publish the line item, not the cart
      // total — fetch the live cart to get it.
      reconcileFromServer();
    }

    // Bare pubsub globals (PUB_SUB_EVENTS is not a window property); `typeof` on an
    // undeclared name is safe. Retry until pubsub.js is ready — this script can execute
    // before it on some load orders.
    (function attachCartUpdate(tries) {
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
          return;
        }
      } catch (e) {}
      if (tries < 80) setTimeout(function () { attachCartUpdate(tries + 1); }, 100);
    })(0);

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
